module.exports = __webpack_public_path__ + "static/media/location-black.e877a632.png";